export default __webpack_public_path__ + "static/media/gallery06.afac17a8.jpg";